{
  "flows": {
    "heroMinimalMount": {
      "steps": [],
      "trigger": "lifecycle"
    },
    "navigateToSignup": {
      "steps": [
        {
          "action": "navigate",
          "params": {
            "route": "/signup"
          },
          "type": "basic"
        }
      ],
      "trigger": "event"
    }
  },
  "schemaVersion": "4.0",
  "blockType": "hero-minimal"
}
